import { render, staticRenderFns } from "./rescindOccupy.vue?vue&type=template&id=10e971f5&scoped=true"
import script from "./rescindOccupy.vue?vue&type=script&lang=js"
export * from "./rescindOccupy.vue?vue&type=script&lang=js"
import style0 from "./rescindOccupy.vue?vue&type=style&index=0&id=10e971f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e971f5",
  null
  
)

export default component.exports